<template>
  <BaseModal modalColor="border-warning bg-warning" iconModal="fa fa-warning" subtitulo="Editar cliente"
             col-md="col-md-3" offset="3">
    <template v-slot:modalContent>
      <form ref="editarForm" @submit.prevent="submitEditForm">
        <div class="box-body">
          <div class="form-group" v-if="isAdminView">
            <FloatLabel variant="on">
              <Select
                  v-model="dado.empresa"
                  inputId="empresa"
                  :options="empresas"
                  optionLabel="razao_social"
                  optionValue="id"
                  size="small"
                  filter
                  style="width: 100%"
                  :invalid="campoVazio.includes('empresa')"
              >
                <template #emptyfilter>
                  Nenhum resultado encontrado
                </template>
              </Select>
              <label for="empresa">
                <strong>Empresa: <span class="text-danger font-bold">*</span></strong>
              </label>
            </FloatLabel>
          </div>
          <div class="form-group">
            <FloatLabel variant="on">
              <InputText id="first_name" v-model="dado.first_name" size="small" style="width: 100%"/>
              <label for="first_name"><strong>Nome: </strong></label>
            </FloatLabel>
          </div>
          <div class="form-group">
            <FloatLabel variant="on">
              <InputText id="last_name" v-model="dado.last_name" size="small" style="width: 100%"/>
              <label for="last_name"><strong>Sobrenome: </strong></label>
            </FloatLabel>
          </div>
          <div class="form-group">
            <FloatLabel variant="on">
              <InputText id="email" type="email" v-model="dado.email" size="small" style="width: 100%"/>
              <label for="email"><strong>E-mail: </strong></label>
            </FloatLabel>
          </div>
          <div class="form-group ">
            <Checkbox v-model="dado.is_active" :binary="true" inputId="is_active"/>
            <label for="is_active"><strong>Ativo</strong></label>
          </div>
          <div class="form-group" v-if="isAdminView">
            <Checkbox v-model="dado.is_staff" :binary="true" inputId="is_staff"/>
            <label for="is_staff"><strong>Equipe</strong></label>
          </div>
          <div class="form-group" v-if="isAdminView">
            <Checkbox v-model="dado.is_superuser" :binary="true" inputId="is_superuser"/>
            <label for="is_superuser"><strong>Super Usuário</strong></label>
          </div>
          <div class="ibox-footer">
            <div class="float-right">
              <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
            </div>
            <button class="btn btn-danger font-bold" @click="$emit('fechar')">
              Cancelar
            </button>
          </div>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "EditarUser",
  components: {
    BaseModal,
  },
  props: {
    usuarioId: Number,
    isAdminView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      empresas: [],
      dado: {},
      erro: null,
      campoVazio: [],
    }
  },
  emits: ["fechar", "atualizarDados"],
  methods: {
    async getDado() {
      const url = this.isAdminView 
        ? apiUrl.usuarios.adminRetrieveUpdateDestroy(this.usuarioId)
        : apiUrl.usuarios.retrieveUpdateDestroy(this.usuarioId);
      const resultado = await apiRequest("GET", url);
      if (resultado.success) {
        this.dado = resultado.data;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getEmpresas() {
      const resultado = await apiRequest("GET", `${apiUrl.empresas.createList}?status=A`);
      if (resultado.success) {
        this.empresas = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar empresas!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitEditForm() {
      this.dado.username = this.dado.email;
      const url = this.isAdminView 
        ? apiUrl.usuarios.adminRetrieveUpdateDestroy(this.usuarioId)
        : apiUrl.usuarios.retrieveUpdateDestroy(this.usuarioId);
      const resultado = await apiRequest("PATCH", url, this.dado);
      if (resultado.success) {
        this.$emit("atualizarDados", resultado.data);
        this.$toastMessage("success", "Registro alterado com sucesso!");
        this.$emit('fechar');
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao alterar registro!");
        console.error("Erro ao salvar:", resultado.error);
        this.campoVazio = Object.keys(resultado.error);
      }
    },
  },
  mounted() {
    if (this.isAdminView) {
      this.getEmpresas();
    }
    this.getDado();
  },
}
</script>

<style>
.p-checkbox + label {
  margin-left: 0.5rem;
}
</style>
